var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"the-brands-list__item",attrs:{"href":_vm.brand.externalUrl,"target":"_blank"}},[_c('img',{staticClass:"swiper-lazy",attrs:{"data-src":_vm.apiUrl(_vm.brand.previewImage),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }